export { default } from "./Workflow";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-admin/Workflow/index.js